import React from 'react';
import './footer.scss'

const Footer = () => {
	return (
		<>
			<div className="mainFooter">
				<div className="subFooter">
					<p>Copyright © 2025, John Doe. All Rights Reserved.</p>
				</div>
			</div>
		</>
	);
};

export default Footer;